import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import CacheBuster from 'react-cache-buster'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import Login from './pages/Login'
import SellerDashboard from './pages/SellerDashboard'
import NewQuotation from './pages/NewQuotation'
import AssistantQuotation from './pages/AssistantQuotation'
import QuoteEditor from './pages/QuoteEditor'
import ClientView from './pages/ClientView'
import CRMPage from "./crm/pages/CRMPageWrapper"
import TasksPage from "./crm/pages/TasksPageWrapper"
import DashboardPage from "./pages/DashboardPage"
import EngagementPanel from "./pages/EngagementPanel"
import SettingsPage from "./crm/pages/SettingsPage"
import VouchersPage from "./crm/pages/VouchersPageWrapper"
import TeamChatPageWrapper from './crm/pages/TeamChatPageWrapper';
import KnowledgeBasePage from './crm/pages/KnowledgeBasePage';
import AereoPage from './pages/AereoPage'
import TaskNotificationListener from './components/TaskNotificationListener'
import './styles/variables.css'
import './styles/mobile.css'

const version = process.env.REACT_APP_VERSION || '1.0.0'

// Usa o contexto compartilhado — sem chamadas extras ao Supabase
function PrivateRoute({ children }) {
  const { initializing, user } = useAuth()

  if (initializing) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
        color: 'white'
      }}>
        Carregando...
      </div>
    )
  }

  return user ? children : <Navigate to="/login" replace />
}

function LoadingComponent() {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
      color: 'white',
      flexDirection: 'column',
      gap: '1rem'
    }}>
      <div>Verificando atualizações...</div>
    </div>
  )
}

function AppRoutes() {
  return (
    <BrowserRouter>
      {/* AuthProvider dentro do BrowserRouter para useNavigate funcionar */}
      <AuthProvider>
        <TaskNotificationListener />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/app" element={<PrivateRoute><SellerDashboard /></PrivateRoute>} />
          <Route path="/app/nova" element={<PrivateRoute><NewQuotation /></PrivateRoute>} />
          <Route path="/app/dashboard" element={<PrivateRoute><SellerDashboard /></PrivateRoute>} />
          <Route path="/app/config" element={<PrivateRoute><SettingsPage /></PrivateRoute>} />
          <Route path="/app/conversas" element={<PrivateRoute><CRMPage /></PrivateRoute>} />
          <Route path="/app/tarefas" element={<PrivateRoute><TasksPage /></PrivateRoute>} />
          <Route path="/app/dashboard-pipeline" element={<PrivateRoute><DashboardPage /></PrivateRoute>} />
          <Route path="/app/engajamento" element={<PrivateRoute><EngagementPanel /></PrivateRoute>} />
          <Route path="/app/vouchers" element={<PrivateRoute><VouchersPage /></PrivateRoute>} />
          <Route path="/app/equipe" element={<PrivateRoute><TeamChatPageWrapper /></PrivateRoute>} />
          <Route path="/app/base" element={<PrivateRoute><KnowledgeBasePage /></PrivateRoute>} />
          <Route path="/app/aereo" element={<PrivateRoute><AereoPage /></PrivateRoute>} />
          <Route path="/app/assistente" element={<PrivateRoute><AssistantQuotation /></PrivateRoute>} />
          <Route path="/app/cotacao/:id" element={<PrivateRoute><QuoteEditor /></PrivateRoute>} />
          <Route path="/c/:link" element={<ClientView />} />
          <Route path="/" element={<Navigate to="/login" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  )
}

function App() {
  const isProduction = process.env.NODE_ENV === 'production'

  return (
    <CacheBuster
      currentVersion={version}
      isEnabled={isProduction}
      isVerboseMode={false}
      loadingComponent={<LoadingComponent />}
      metaFileDirectory={'.'}
    >
      <AppRoutes />
    </CacheBuster>
  )
}

export default App
